import { z } from "zod";
/** Exact locator in the immutable normalized evidence manifest; offsets count Unicode code points. */
export const evidenceLocatorSchema = z
    .object({
    kind: z.enum(["css", "pdf-page", "document"]),
    value: z.string().min(1).max(500),
    textStart: z.number().int().nonnegative(),
    textEnd: z.number().int().nonnegative(),
    heading: z.string().max(500).nullable().optional(),
})
    .strict()
    .refine((value) => value.textEnd >= value.textStart, {
    path: ["textEnd"],
    message: "Must not precede textStart",
});
//# sourceMappingURL=evidence-locator.js.map